export interface Cam { lon: number; lat: number; zoom: number; pitch: number; bearing: number }
export interface ViewState { circuit: number | null; t: number | null; cam: Cam | null }

const num = (s: string | null): number | null => (s === null || s === '' || Number.isNaN(Number(s)) ? null : Number(s));

export function parseViewState(p: URLSearchParams): ViewState {
  const cam = p.get('cam')?.split(',').map(Number);
  return { circuit: num(p.get('circuit')), t: num(p.get('t')),
    cam: cam && cam.length === 5 && cam.every(Number.isFinite) ? { lon: cam[0]!, lat: cam[1]!, zoom: cam[2]!, pitch: cam[3]!, bearing: cam[4]! } : null };
}
export function serializeViewState(v: ViewState, base = new URLSearchParams()): URLSearchParams {
  const p = new URLSearchParams(base);
  v.circuit === null ? p.delete('circuit') : p.set('circuit', String(v.circuit));
  v.t === null ? p.delete('t') : p.set('t', String(Math.round(v.t * 10) / 10));
  v.cam === null ? p.delete('cam') : p.set('cam', [v.cam.lon, v.cam.lat, v.cam.zoom, v.cam.pitch, v.cam.bearing].map(x => Math.round(x * 100) / 100).join(','));
  return p;
}
